import FieldsInterface from "@app/Interface/FieldsInterface";

export default class EzFeedFunctions {

    static getEzFeedFields = (): FieldsInterface => {

        const fields: FieldsInterface = {
            ezUsername: {
                fieldId: "ezUsername",
                formFieldId: "ezUsername",
                value: "",
                label: "EZ Feed Username",
                validated: "default",
                required: true,
                helperTextInvalid: "Please enter a username."
            },
            ezPassword: {
                fieldId: "ezPassword",
                formFieldId: "ezPassword",
                value: "",
                label: "EZ Feed Password",
                validated: "default",
                required: true,
                helperTextInvalid: "Please enter a password."
            },
        };

        return fields;

    }

}